<template>
  <div>
    <a-tabs v-model="tabs" default-active-key="1"
            @change="handelStatusChange">
      <a-tab-pane key="1">
        <span slot="tab">
          待受理
          <span class="lable">（{{ type_counts.create }}）</span>
        </span>
      </a-tab-pane>
      <a-tab-pane key="2">
        <span slot="tab">
          已受理
          <span class="lable">（{{ type_counts.accept }}）</span>
        </span>
      </a-tab-pane>
      <a-tab-pane key="3">
        <span slot="tab">
          已解决
          <span class="lable">（{{ type_counts.complete }}）</span>
        </span>
      </a-tab-pane>
      <a-tab-pane key="4,5,6">
        <span slot="tab">
          已关闭
          <span class="lable">（{{ type_counts.accept_fail }}）</span>
        </span>
      </a-tab-pane>
    </a-tabs>
    <a-row :gutter="30" style="padding-top: 30px">
      <a-col span="8" style="margin-bottom: 25px">
        <a-row type="flex" align="top">
          <a-col span="6" class="form-label">申请时间</a-col>
          <a-col span="18">
            <a-range-picker
                showTime
                style="display: block; width: auto"
                format="YYYY-MM-DD"
                v-model="params.time"
            />
          </a-col>
        </a-row>
      </a-col>
      <a-col span="8" style="margin-bottom: 25px">
        <a-row type="flex" align="top">
          <a-col span="6" class="form-label">IE</a-col>
          <a-col span="18">
            <a-auto-complete
                allowClear
                style="display: block"
                :dataSource="suggestion"
                @search="handleSearch"
                v-model="params.ie_user_id"
                placeholder="请输入关键字"
            ></a-auto-complete>
          </a-col>
        </a-row>
      </a-col>
      <a-col span="8" style="margin-bottom: 25px">
        <a-row type="flex" align="top">
          <a-col span="6" class="form-label">订单号</a-col>
          <a-col span="18">
            <a-input
                style="display: block"
                placeholder="请输入关键字"
                v-model="params.order_no"
            ></a-input>
          </a-col>
        </a-row>
      </a-col>
    </a-row>
    <a-row type="flex" justify="space-between">
      <a-col>
        <a-button
            type="primary"
            style="margin-right: 12px; padding: 0 30px"
            @click="getFilterData()"
        >筛选
        </a-button
        >
        <a-button style="margin-right: 12px" @click="resetParams"
        >清空筛选条件
        </a-button
        >
        <span>共找到 {{ pagination.total }} 条信息</span>
      </a-col>
    </a-row>
    <div class="data-table" style="padding: 30px 0">
      <a-table
          :columns="columns"
          :dataSource="dataSource"
          rowKey="ask_help_id"
          :pagination="pagination"
          :loading="loading"
          @change="getData"
          :customRow="rowClick"
      >
        <template slot="hunter" slot-scope="name, record">
          <span>{{ name }}</span>
          <span class="badge" v-if="record.is_sign == 1">签</span>
        </template>
        <template slot="ask_type_text" slot-scope="name, record">
          <span v-for="(item,index) in name">{{ item }}{{ (index + 1) == name.length ? '' : ',' }}</span>
        </template>
        <template slot="status" slot-scope="status, record">
          <span
              :class="{
              tag: true,
              blue:
                [
                  'HUNTER_REFUSE','DELIVER'
                ].indexOf(status) > -1,
            }"
              v-if="record.source=='columbus_mini_app'"
          >投</span
          >
          <span
              :class="{
              tag: true,
              blue:
                [
                  'CREATED',
                  'AUDIT_PASSED',
                  'AUDIT_FAILED',
                  'SUBMIT_FAILED',
                ].indexOf(status) > -1,
            }"
          >推</span
          >
          <span
              :class="{
              tag: true,
              blue:
                [
                  'SUBMIT_PASSED',
                  'INTERVIEW',
                  'INTERVIEW_FAILED',
                  'CLOSED',
                ].indexOf(status) > -1,
            }"
          >面</span
          >
          <span :class="{ tag: true, blue: ['OFFERED'].indexOf(status) > -1 }"
          >录</span
          >
          <span
              :class="{
              tag: true,
              blue: ['ENTERED', 'NOT_ENTERED'].indexOf(status) > -1,
            }"
          >职</span
          >
          <span
              :class="{
              tag: true,
              blue:
                ['COMPLETED', 'NOT_COMPLETED', 'UNSETTLED', 'SETTLED'].indexOf(
                  status
                ) > -1,
            }"
          >保</span
          >
        </template>
        <template slot="action" slot-scope="{ status }, record">
          <div v-if="tabs==1">
            <a-row
                type="flex"
                justify="center"
                align="middle"
            >
              <a-col>
                <a-button type="link" @click.stop="nextStep(record,1)"
                >受理
                </a-button
                >
              </a-col>
              <a-col>
                <a-button
                    type="link"
                    @click.stop="nextStep(record,2)"
                >拒绝
                </a-button
                >
              </a-col>
            </a-row>
          </div>
          <div v-else-if="tabs==2">
            <a-row
                type="flex"
                justify="center"
                align="middle"
            >
              <a-col>
                <a-button type="link" @click.stop="nextStep(record,3)"
                >已解决
                </a-button
                >
              </a-col>
              <a-col>
                <a-button
                    type="link"
                    @click.stop="nextStep(record,4)"
                >失败
                </a-button
                >
              </a-col>
            </a-row>
          </div>
          <div v-else-if="tabs==3||tabs==4">
            <a-row
                type="flex"
                justify="center"
                align="middle"
            >
              <a-col>
                <a-button type="link" @click.stop="nextStep(record,5)"
                >查看受理记录
                </a-button
                >
              </a-col>
            </a-row>
          </div>
        </template>
      </a-table>
    </div>
    <a-modal v-model="visible" :maskClosable="false" :centered="true" :closable="false" :title="poptitle"
             on-ok="handleOk">
      <template slot="footer">
        <a-button key="back" @click="tag!=5?$message.info('取消操作'):null;visible=false;textnum=''">
          取消
        </a-button>
        <a-button v-if="tag!=5" key="submit" type="primary" :loading="loading" @click="handleOk(tag)">
          {{ tag == 2 || tag == 3 || tag == 4 ? '完成' : '确认' }}
        </a-button>
      </template>
      <p v-if="tag==1">确认要受理此求助申请吗？</p>
      <div v-else-if="tag==2">
        <a-textarea placeholder="请填写拒绝原因" :maxLength="50" :rows="4" v-model="textnum"/>
        <div style="float: right">{{ textnum.length + '/50' }}</div>
      </div>
      <div v-else-if="tag==3">
        <a-row>
          <a-col :span="4" style="text-align: right">
            救助结果：
          </a-col>
          <a-col :span="20">
            已解决
          </a-col>
        </a-row>
        <a-row style="margin-top: 10px">
          <a-col :span="4" style="text-align: right">
            备注信息：
          </a-col>
          <a-col :span="20">
            <a-textarea v-model="solve_reason" :maxLength="50" placeholder="请填写备注信息（选填）" :rows="4"/>
            <div style="float: right">{{ solve_reason.length + '/50' }}</div>
          </a-col>
        </a-row>
      </div>
      <div v-else-if="tag==4">
        <a-row>
          <a-col :span="4" style="text-align: right">
            救助结果：
          </a-col>
          <a-col :span="20">
            失败
          </a-col>
        </a-row>
        <a-row style="margin-top: 10px">
          <a-col :span="4" style="text-align: right">
            <span style="color: red">*</span>失败原因：
          </a-col>
          <a-col :span="20">
            <a-textarea v-model="solve_reason_ok" :maxLength="50" placeholder="请填写备注信息（必填）" :rows="4"/>
            <div style="float: right">{{ solve_reason_ok.length + '/50' }}</div>
          </a-col>
        </a-row>
      </div>
      <div v-else-if="tag==5" style="max-height: 400px;overflow-y: scroll;padding-top: 20px">
        <a-timeline>
          <a-timeline-item v-for="(item,index) in hunter_help_list" :key="index">
            <a-row>
              <a-col :span="8">
                {{ item.updated_at }}
              </a-col>
              <a-col :span="16">
                <span :style="{
              color:item.ask_help_status==1?'rgb(245, 154, 35)':
                  item.ask_help_status==2?'rgb(2, 167, 240)':
                      item.ask_help_status==3?'rgb(112, 182, 3)':
                          item.ask_help_status==4?'rgb(51, 51, 51)':
                              item.ask_help_status==5?'rgb(217, 0, 27)':'rgb(51, 51, 51)'
            }">{{
                    item.ask_help_status == 1 ? '待受理' :
                        item.ask_help_status == 2 ? '已受理' :
                            item.ask_help_status == 3 ? '已完成' :
                                item.ask_help_status == 4 ? '已撤回' :
                                    item.ask_help_status == 5 ? '已拒绝' : '已拒绝'
                  }}</span>
              </a-col>
            </a-row>
            <a-row>
              <a-col :span="8">
              </a-col>
              <a-col :span="16">
                <p>{{
                    item.ask_help_status == 1 ? '提交时间：' + item.updated_at :
                        item.ask_help_status == 2 ? '受理时间：' + item.updated_at :
                            item.ask_help_status == 3 ? '完成时间：' + item.updated_at :
                                item.ask_help_status == 4 ? '撤回时间：' + item.updated_at :
                                    item.ask_help_status == 5 ? '拒绝时间：' + item.updated_at : '拒绝时间：' + item.updated_at
                  }}</p>
              </a-col>
            </a-row>
            <a-row v-if="item.ask_help_status == 1 && item.ask_type_text && item.ask_type_text.length>0">
              <a-col :span="8">
              </a-col>
              <a-col :span="16">
                <p>
                  求助类型：<span v-for="(itemask,indexask) in item.ask_type_text"
                             :key="indexask">{{ itemask }}</span>
                </p>
              </a-col>
            </a-row>
            <a-row
                v-if="item.ask_help_status == 2 || item.ask_help_status == 3 || item.ask_help_status == 5 || item.ask_help_status == 6">
              <a-col :span="8">
              </a-col>
              <a-col :span="16">
                <p>
                  受理人员：
                  <span>{{ item.ie_name }}</span>
                </p>
              </a-col>
            </a-row>
            <a-row v-if="item.ask_help_status == 3 && item.solve_reason">
              <a-col :span="8">
              </a-col>
              <a-col :span="16">
                <p>
                  备注信息：<span>{{ item.solve_reason }}</span>
                </p>
              </a-col>
            </a-row>
            <a-row v-if="item.ask_help_status == 4">
              <a-col :span="8">
              </a-col>
              <a-col :span="16">
                <p>
                  操作人员：<span>用户主动撤回</span>
                </p>
              </a-col>
            </a-row>
            <a-row v-if="(item.ask_help_status == 5||item.ask_help_status == 6) && item.reject_reason">
              <a-col :span="8">
              </a-col>
              <a-col :span="16">
                <p>
                  拒绝原因：<span>{{ item.reject_reason }}</span>
                </p>
              </a-col>
            </a-row>
          </a-timeline-item>
        </a-timeline>
      </div>
    </a-modal>
    <a-drawer
        :visible="drawer"
        :closable="false"
        width="1000"
        @close="drawer = !drawer"
        :destroyOnClose="true"
    >
      <a-row
          type="flex"
          justify="space-between"
          align="middle"
          style="paddingbottom: 40px"
      >
        <a-col style="cursor: pointer" @click="drawer = !drawer">
          <icon-font type="guanbi" :style="{ fontSize: '19px' }"/>
        </a-col>
        <a-col style="cursor: pointer" @click="viewDetail">
          <a-icon type="fullscreen"/>
          在新窗口打开
        </a-col>
      </a-row>
      <order-detail :id="order_id" :ask_help_id="ask_help_id" :hunter_state="3"></order-detail>
    </a-drawer>
  </div>
</template>

<script>
import Api from "@/api";
import OrderDetail from "@/app/admin/order/order-detail";

export default {
  name: "help",
  data() {
    return {
      tabs: "1",
      getdata: [],
      dataSource: [],
      columns: [
        // {
        //   title: "做单号",
        //   dataIndex: "id",
        // },
        {
          title: "订单号",
          dataIndex: "order_no",
        },
        {
          title: "职位",
          dataIndex: "job_name",
        },
        {
          title: "猎头",
          dataIndex: "hunter_name",
          scopedSlots: {customRender: "hunter"},
        },
        {
          title: "IE",
          dataIndex: "ie_name",
        },
        {
          width: "200px",
          align: "center",
          title: "订单阶段",
          dataIndex: "status",
          scopedSlots: {customRender: "status"},
        },
        {
          title: "求助类型",
          align: "center",
          dataIndex: "ask_type_text",
          scopedSlots: {customRender: "ask_type_text"},
        },
        {
          title: "申请时间",
          dataIndex: "updated_at",
        },
        {
          align: "center",
          title: "操作",
          key: "action",
          scopedSlots: {customRender: "action"},
        }
      ],
      params: {
        ie_user_id: "",
        time: [],
        order_no: ""
      },
      loading: false,
      suggestion: [],
      order_id: undefined,
      ask_help_id:undefined,
      pagination: {
        pageSize: 10,
        current: 1,
        total: 0,
        pageSizeOptions: ["10", "20", "50"],
        showTotal: (total) => `共 ${total} 条`,
        showQuickJumper: true,
        showSizeChanger: true,
      },
      chack: null,
      visible: false,
      poptitle: "",
      textnum: "",
      tag: null,
      drawer: false,
      solve_reason: "",
      solve_reason_ok: "",
      hunter_help_list: [],
      type_counts: {}
    };
  },
  components: {
    OrderDetail,
  },
  //this.params.time[0] && this.params.time[0].format("YYYY-MM-DD")
  created() {
    this.chack = 1;
    this.getData(this.pagination, 1);
  },
  methods: {
    viewDetail(record) {
      this.drawer = false;
      let resolveDRoute = this.$router.resolve({
        path: `/order/detail/${this.order_id}`,
      });
      window.open(resolveDRoute.href, "_blank");
    },
    handelStatusChange(activeKey) {
      this.loading = true;
      this.chack = activeKey;
      this.pagination.current = 1;
      this.getData(this.pagination, activeKey);
    },
    nextStep(record, title) {
      this.visible = true;
      this.order_id = record.id;
      this.ask_help_id = record.ask_help_id;
      this.tag = title;
      this.tag == 1 ? this.poptitle = '提示' :
          this.tag == 2 ? this.poptitle = '拒绝原因' :
              this.tag == 3 ? this.poptitle = '救助结果' :
                  this.tag == 4 ? this.poptitle = '救助结果' :
                      this.tag == 5 ? this.poptitle = '受理记录' :
                          this.poptitle = '受理记录';
      if (this.tag == 5) {
        Api.hunter.ask_acceptList({
          post_id: this.order_id
        }).then(res => {
          console.log(res)
          if (res.length > 0) {
            this.hunter_help_list = res;
            this.visible = true;
          }else {

          }
        });
      } else {
        this.visible = true;
      }
    },
    handleOk(tag) {
      this.loading = true;
      if (tag == 1) {
        Api.hunter.ask_accept({
          ask_help_id: this.ask_help_id
        }).then(() => {
          this.$message.success('受理成功');
          this.loading = false;
          this.visible = false;
          this.chack = 1;
          this.getData(this.pagination, 1);
        });
      } else if (tag == 2) {
        if (this.textnum) {
          Api.hunter.ask_recject({
            ask_help_id: this.ask_help_id,
            reject_reason: this.textnum
          }).then(() => {
            this.$message.success('已拒绝');
            this.loading = false;
            this.visible = false;
            this.chack = 1;
            this.getData(this.pagination, 1);
          });
        } else {
          this.$message.error('请填写拒绝原因');
          this.loading = false;
        }
      } else if (tag == 3 || tag == 4) {
        if (tag == 3) {
          Api.hunter.ask_solve({
            ask_help_id: this.ask_help_id,
            type: 1,
            solve_reason: this.solve_reason
          }).then(() => {
            this.$message.success('已完成');
            this.loading = false;
            this.visible = false;
            this.chack = 2;
            this.getData(this.pagination, 2);
          });
        } else if (tag == 4) {
          if (this.solve_reason_ok) {
            Api.hunter.ask_solve({
              ask_help_id: this.ask_help_id,
              type: 2,
              solve_reason: this.solve_reason_ok
            }).then(() => {
              this.$message.success('已完成');
              this.loading = false;
              this.visible = false;
              this.chack = 2;
              this.getData(this.pagination, 2);
            });
          } else {
            this.$message.error('请填写失败原因');
            this.loading = false;
          }
        }
      }
    },
    getData(pagination) {
      if (pagination) {
        let pager = {...this.pagination};
        pager.current = pagination.current;
        pager.pageSize = pagination.pageSize;
        this.pagination = pager;
      }
      Api.hunter.ask_help({
        created_start: this.params.time[0] && this.params.time[0].format("YYYY-MM-DD"),
        created_end: this.params.time[1] && this.params.time[1].format("YYYY-MM-DD"),
        ie_name: this.params.ie_user_id,
        order_no: this.params.order_no,
        statuses: this.chack,
        page: this.pagination.current,
        limit: this.pagination.pageSize,
      }).then(res => {
        console.log(res)
        this.getdata = res.list;
        this.type_counts = res.type_counts;
        this.dataSource = this.getdata;
        this.loading = false;
        this.pagination.total = Number(res.total);
      });
    },
    rowClick(record) {
      return {
        on: {
          click: () => {
            this.drawer = true;

            this.order_id = record.id;
            this.ask_help_id = record.ask_help_id;
          },
        },
      };
    },
    getFilterData() {
      this.pagination.current = 1;
      this.getData(this.tabs);
    },
    resetParams() {
      let params = {
        ie_user_id: "",
        time: [],
        order_no: ""
      };
      this.params = params;
    },
    //IE 搜索建议
    async handleSearch(value) {
      if (!value) return;
      let response = await Api.account.suggest({name: value});
      let arr = [];
      response.forEach((item) => {
        arr.push({value: item.uid, text: item.name});
      });
      this.suggestion = arr;
    },
  },
}
</script>

<style lang="scss">
.lable {
  color: #D9001B;
}

.order-page {
  .ant-table-row {
    cursor: pointer;
  }
}

.tag {
  border: 1px solid #00a2eb;
  padding: 2px 3px;

  &.blue {
    color: #fff;
    background: #00a2eb;
  }

  &:not(:first-child) {
    border-left: none;
  }
}

.badge {
  position: relative;
  display: inline-block;
  color: #fff;
  background: rgb(224, 9, 9);
  font-size: 12px;
  padding: 0 2px;
  border-radius: 2px;
  top: -8px;
  left: 2px;
}

.half-page {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1000;

  .content-box {
    position: absolute;
    top: 0;
    right: 0;
    width: 1600px;
    height: 100%;
    overflow: auto;
    background: #fff;
    box-shadow: 0px 0px 44px 0px rgba(0, 0, 0, 0.16);
    padding: 30px 40px;

    .close {
      cursor: pointer;
    }

    .new_win {
      cursor: pointer;
      color: #999;
      display: flex;
      align-items: center;

      .anticon {
        font-size: 16px;
        margin-right: 6px;
      }
    }
  }
}
</style>
